// extracted by mini-css-extract-plugin
export default {"quote_price":"quote_price___N2QdB"};